import api from "../index";

export const GetAllCountryApi = () => api.get('DropDown/GetAll-Country');
export const GetTermsConditionApi = () => api.get('DropDown/Get-Terms-Condition');
export const GetTermsAndConditionApi = () => api.get(`TermsAndCondition/get`);
export const GetTNCVersionApi = (version) => api.get(`TermsAndCondition/get/${version}`);

export const TermsAndConditionAcceptApi = (userId) => api.get(`TermsAndCondition/accept/${userId}`);
export const GetTermsByTermsApi = (type) => api.get(`TermsAndCondition/GetTermsByTerms/${type}`);
